import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "counter", "collapseIcon"]
  static values = { visibleLimit: { type: Number, default: 4 } }

  connect() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.expanded = !this.expanded
    this.render()
  }

  get expanded() {
    return this.element.dataset.expanded === "true"
  }

  set expanded(value) {
    this.element.dataset.expanded = value ? "true" : "false"
  }

  render() {
    const expanded = this.expanded

    this.labelTargets.forEach((label, index) => {
      label.classList.toggle("hidden", !expanded && index >= this.visibleLimitValue)
    })

    if (this.hasCounterTarget) {
      this.counterTarget.classList.toggle("hidden", expanded)
    }
    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.classList.toggle("hidden", !expanded)
    }
  }
}
